<template>
    <base-view class="report-summary-view">
        <div class="summary-header">
            <veui-span>{{store.materialType}}：</veui-span>
            <veui-dropdown
                ui="link primary"
                :label="store.selectItem.name">
                <veui-option v-for="option in store.selectDatasource"
                    :key="option.id"
                    :value="option.id"
                    :label="option.name"
                    @click="redirect(option.id)"/>
            </veui-dropdown>

            <div class="field">
                <veui-span>广告主：</veui-span>
                <veui-span>{{store.selectItem.aderName}}</veui-span>
            </div>
            <div class="field">
                <veui-span>{{startDate}}</veui-span>
                <veui-span>{{endDate}}</veui-span>
            </div>
        </div>

        <veui-tabs :active="activeTabPath" v-if="showTab">
            <veui-tab v-for="tab in store.tabs"
                :key="tab.label"
                :label="tab.label"
                :to="tab.routePath">
                <router-view v-if="activeTabPath === tab.routePath"/>
            </veui-tab>
        </veui-tabs>
    </base-view>
</template>

<script>
import {omit} from 'lodash';
import Model from './SummaryModel';
import format from 'date-fns/format';
import uri from '@baidu/ve-ria/utils/uri';
import {parseDate} from '@baidu/ve-ria/utils/date';
import BaseView from '@baidu/ve-ria/views/BaseView';
import {Tabs, Tab, Span, Dropdown, Option} from 'veui';
import createView from '@baidu/ve-ria/views/createView';

export default createView(BaseView, Model, {
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-span': Span,
        'veui-dropdown': Dropdown,
        'veui-option': Option
    },
    data() {
        return {
            showTab: true
        };
    },
    computed: {
        endDate() {
            return `至 ${format(parseDate(this.store.filter.endDate), 'YYYY-MM-DD')}`;
        },
        startDate() {
            return `时间段：${format(parseDate(this.store.filter.startDate), 'YYYY-MM-DD')}`;
        },
        activeTabPath() {
            // page信息不包含在tab路由中，因此这里去除pageNo, pageSiz
            return uri.withQuery(this.store.getRoutePath(),
                omit(this.store.getRouteQuery(), ['pageNo', 'pageSize'])
            );
        }
    },
    watch: {
        '$route.path'(val) {
            this.reloadPageStore();
        }
    },
    methods: {
        redirect(associatedId) {
            this.store.filter.associatedId = associatedId;
            this.global.redirect({
                type: 'push',
                url: this.store.prepareRedirectUrl()
            });
            this.reloadPageStore();
        },

        /**
         * report相关页面公用了此View，因此report间页面切换需要更新store信息
         */
        reloadPageStore() {
            // 这里用了个showTab开关，是为了让tabs重新加载一遍。直接使用tabs增减没有效果，会产生tab不匹配bug.
            // 特别是选择框改变时, 只是每个tab的跳转路由发生了变化。
            this.showTab = false;
            this.$nextTick(() => {
                this.store.init();
                this.showTab = true;
            });
        }
    }
});
</script>
<style lang="less">
@import '~veui-theme-one/lib.less';
.report-summary-view {
    .summary-header {
        font-size: @veui-font-size-normal;
        color: @veui-text-color-weak;
        margin-bottom: 30px;
        margin-top: 40px;

        .field {
            display: inline;
            margin-left: 30px;
        }

        .veui-dropdown[ui~=link] {
            max-width: none;
        }
    }
}
</style>

